import { Directive, HostListener, ElementRef, OnInit } from "@angular/core";
import { NgControl } from "@angular/forms";
import { intersection } from "lodash";

@Directive({
  selector: "[myCurrencyFormatter]"
})


export class CurrencyFormatterDirective implements OnInit {
  private DECIMAL_SEPARATOR: string;
  private THOUSANDS_SEPARATOR: string;
  private PADDING = "000000";
  private el: HTMLInputElement;
  constructor(
    private elementRef: ElementRef,
    private control: NgControl
    //    private cPipe: MyCurrencyPipe
  ) {
    this.el = this.elementRef.nativeElement;
    this.DECIMAL_SEPARATOR = ".";
    this.THOUSANDS_SEPARATOR = ",";
    //  this.currencyPipe = this.cPipe;
  }

  ngOnInit() {
    //console.log('ngoninit called');

    //this.el.value = this.transform1(this.el.value);
  }

  @HostListener("focus", ["$event.target.value"])
  onFocus(value) {
    this.el.value = this.parse1(value); // opossite of transform
  }

  @HostListener("blur", ["$event.target.value"])
  onBlur(value) {
    this.el.value = this.transform1(value);
  }

  transform1(value: number | string, fractionSize: number = 2): string {
    if (value.toString().substr(0, 1) === '$') {
      value = +value.toString().substr(1, value.toString().length - 1);
    }
    let [integer, fraction = ""] = (value || "").toString()
      .split(this.DECIMAL_SEPARATOR);

    fraction = fractionSize > 0
      ? this.DECIMAL_SEPARATOR + (fraction + this.PADDING).substring(0, fractionSize)
      : "";

    integer = integer.replace(/,/g, '');
    integer = parseInt(integer).toString();
    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

    if (integer.length === 0 || isNaN(parseInt(integer))) {
      this.control.control.setValue("");
      //console.log('value set null');
      return "";
    }

    this.control.control.setValue(integer + fraction);
    //console.log('value set ' + integer + fraction);
    return '$' + integer + fraction;
  }

  parse1(value: string, fractionSize: number = 2): string {
    if (value.toString().substr(0, 1) === '$') {
      value = value.toString().substr(1, value.toString().length - 1);
    }
    let [integer, fraction = ""] = (value || "").split(this.DECIMAL_SEPARATOR);

    integer = integer.replace(/,/g, '');
    integer = parseInt(integer).toString();
    integer = integer.replace(new RegExp(this.THOUSANDS_SEPARATOR, "g"), "");
    fraction = parseInt(fraction, 10) > 0 && fractionSize > 0
      ? this.DECIMAL_SEPARATOR + (fraction + this.PADDING).substring(0, fractionSize)
      : "";
    if (integer.length === 0 || isNaN(parseInt(integer))) {
      this.control.control.setValue("");
      //console.log('value set null');
      return "";
    }
    this.control.control.setValue(integer + fraction);
    //console.log('value set ' + integer + fraction);

    return integer + fraction;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/currency-formatter.directive.ts